/*
 * Copyright © 2024 Himitsu Lab Limited. All Rights Reserved.
 */

/* eslint-disable prettier/prettier */
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  "addExternalCamera": "外部カメラを追加",
  "attach": "添付",
  "camera": "カメラ",
  "cameraOn": "カメラオン",
  "cameraOff": "カメラオフ",
  "characters": "キャラクター",
  "close": "近い",
  "coHost": "共同ホスト",
  "currentStepUpPrice": "現在のステップアップ価格",
  "custom": "カスタム",
  "doYouNeedToEndTheMeeting": "会議を終了する必要がありますか？",
  "doYouWantToLeaveTheMeeting": "会議から退出しますか?",
  "doYouWantToSave": "保存しますか？",
  "enableDualDeviceSelection": "デュアルデバイス選択を有効にする",
  "end": "終わり",
  "fileSizeExceedsLimit": "ファイルサイズが制限を超えています",
  "fullScreen": "全画面表示",
  "groupChat": "グループチャット",
  "gridView": "グリッドビュー",
  "handRaise": "挙手",
  "host": "ホスト",
  "hostGrantedPermissionToTalk": "ホストは話す許可を与えました",
  "hostRemovedPermissionToTalk": "ホストが通話許可を削除しました",
  "hostStartedRecordingTheScreen": "ホストが画面の録画を開始しました",
  "hostStartedRecording": "司会者が録画を開始",
  "hostView": "ホストビュー",
  "initialStepUp": "最初のステップアップ",
  "language": "言語",
  "leave": "離れる",
  "limitPleaseUploadASmallerFileOrUploadFilesInADriveAndShareTheLink": "制限があります。小さいファイルをアップロードするか、ドライブにファイルをアップロードしてリンクを共有してください。",
  "liveChat": "ライブチャット",
  "meetingWillEndIn": "会議は に終了します",
  "message": "メッセージ",
  "messageLengthExceeds": "メッセージの長さが超過しています",
  "mic": "マイク",
  "microphoneOn": "マイクオン",
  "microphoneOff": "マイクオフ",
  "minutes": "分",
  "multiSessionDoYouWantToLeave": "マルチセッション。帰りたい？",
  "muteAll": "すべてミュート",
  "noResultsFound": "結果が見つかりません",
  "ok": "わかりました",
  "onlyImagesAudioAndPdfFilesAreSupported": "画像、音声、PDFファイルのみがサポートされています",
  "others": "その他",
  "participants": "参加者",
  "pin": "ピン",
  "pip": "ピップ",
  "pleaseTurnOnYourMicToStartRecording": "録音を開始するにはマイクをオンにしてください",
  "privateChat": "プライベートチャット",
  "raisedTheirHand": "手を挙げた",
  "recordingInProgress": "録音中",
  "save&NotifyMe": "保存して通知する",
  "screenShare": "画面共有",
  "screenShareOn": "画面共有オン",
  "screenShareOff": "画面共有オフ",
  "searchParticipants": "参加者を検索する",
  "send": "送信",
  "settings": "設定",
  "shareShow": "シェアショー",
  "staged": "段階的",
  "startRecording": "録画を開始",
  "stepUp": "ステップアップ",
  "stepUpAmountError": "ステップアップ量エラー",
  "stepUpAmountCannotBeLessThanTheOngoingStepUpAmountOf": "ステップアップ額は、現在のステップアップ額より少なくすることはできません。",
  "stepUpCompletedAt": "ステップアップ完了",
  "streamKey": "ストリームキー",
  "stopRecording": "録画を停止",
  "theFileSizeExceedsThe": "ファイルサイズが",
  "toSpeakRaiseYourHandAndWaitForTheHostToUnmuteYou": "話す場合は手を挙げて、主催者がミュートを解除するのを待ちます",
  "toShareYourScreenKindlyRequestTheHostToUnmuteYou": "画面を共有するには、ホストにミュート解除を依頼してください。",
  "typeAMessage": "メッセージを入力してください",
  "unmute": "ミュートを解除する",
  "unmuteAll": "すべてのミュートを解除",
  "unpin": "ピン留めを外す",
  "unsupportedFileType": "サポートされていないファイルタイプ",
  "waitForHost": "ホストを待つ",
}
